import { render, staticRenderFns } from "./FeedsStatusBadge.vue?vue&type=template&id=1ce51cd8&scoped=true"
import script from "./FeedsStatusBadge.vue?vue&type=script&lang=js"
export * from "./FeedsStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./FeedsStatusBadge.vue?vue&type=style&index=0&id=1ce51cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce51cd8",
  null
  
)

export default component.exports